import { Box } from '@chakra-ui/react'
import Header from './Header/Header'

const Layout = ({ children }) => {
  return (
    <Box minH="100vh" bg="gray.50">
      <Header />
      <Box as="main" p={4} maxW="container.2xl" mx="auto">
        {children}
      </Box>
    </Box>
  )
}

export default Layout